import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card, Row, Col, Spin, Button, message } from 'antd'; // message eklendi
import { ArrowLeftOutlined, EyeOutlined, CloseOutlined } from '@ant-design/icons';
import { useTheme } from '../../../context/ThemeContext'; // Theme context varsa açabilirsin

const ImageArchivePage = () => {
  const { maptriksId } = useParams();
  const navigate = useNavigate();
  const { darkMode } = useTheme();
  
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    if (maptriksId) {
      fetchImages();
    }
  }, [maptriksId]);

  const fetchImages = async () => {
    try {
      setLoading(true);
      const baseUrl = 'https://dosya.atmturkiye.com/atmpoint';
      const folderPrefix = `atmpoint/poifoto/${maptriksId}/`; 
      const listUrl = `${baseUrl}?prefix=${folderPrefix}`;
      const response = await fetch(listUrl);
      const str = await response.text();
      
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(str, "text/xml");
      const elements = xmlDoc.getElementsByTagName("Contents");
      const imageList = [];

      for (let i = 0; i < elements.length; i++) {
        const key = elements[i].getElementsByTagName("Key")[0].textContent;
        if (key !== folderPrefix) {
            let imageUrl = `${baseUrl}/${key}`;
            imageList.push({
              id: `img_${i}`,
              url: imageUrl,
              filename: key.split('/').pop()
            });
        }
      }
      setImages(imageList);
    } catch (error) {
      console.error("Hata:", error);
      message.error("Resimler yüklenirken hata oluştu");
    } finally {
      setLoading(false);
    }
  };

  const handleImageClick = (image) => {
    setSelectedImage(image);
  };

  const closeImageModal = () => {
    setSelectedImage(null);
  };

  const handleBack = () => {
    navigate(-1);
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh', background: darkMode ? '#1b1d22' : '#f5f5f5' }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div style={{ padding: 24, background: darkMode ? '#1b1d22' : '#f5f5f5', minHeight: '100vh' }}>
      
      {/* Header Kısmı */}
      <div style={{ marginBottom: 24, display: 'flex', alignItems: 'center', gap: 16 }}>
        <Button icon={<ArrowLeftOutlined />} onClick={handleBack} type="text" size="large">
          Geri
        </Button>
        <div>
          <h1 style={{ margin: 0, color: darkMode ? '#fff' : '#333', fontSize: 24, fontWeight: 600 }}>
            Resim Arşivi - {maptriksId}
          </h1>
          <span style={{ color: darkMode ? '#999' : '#666', fontSize: 14 }}>
            ({images.length} resim listelendi)
          </span>
        </div>
      </div>
      {images.length > 0 ? (
        <Row gutter={[16, 16]}>
          {images.map((image, index) => (
            <Col 
              key={image.id || index}
              xs={24}  
              sm={12}  
              md={8}  
              lg={6}   
              xl={6}   
            >
              <Card
                hoverable
                style={{
                  background: darkMode ? '#2a2d35' : '#fff',
                  border: darkMode ? '1px solid #3a3d45' : '1px solid #f0f0f0',
                  borderRadius: 8,
                  overflow: 'hidden'
                }}
                bodyStyle={{ padding: 8 }}
                cover={
                  <div 
                    style={{ 
                      height: 200,
                      background: '#0f1115',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      overflow: 'hidden'
                    }} 
                    onClick={() => handleImageClick(image)}
                  >
                    <img
                      alt={image.filename}
                      src={image.url}
                      loading="lazy"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain' 
                      }}
                    />
                  </div>
                }
                actions={[
                  <EyeOutlined key="view" onClick={() => handleImageClick(image)} />       
                ]}
              >
                <div style={{ textAlign: 'center', marginTop: -5 }}>
                  <div 
                    style={{ 
                      fontSize: 12, 
                      color: darkMode ? '#ddd' : '#333',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis'
                    }}
                    title={image.filename} 
                  >
                    {image.filename}
                  </div>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      ) : (
        <div style={{ textAlign: 'center', padding: 48, color: darkMode ? '#999' : '#666' }}>
          <p>Bu klasörde görüntülenecek resim bulunamadı.</p>
        </div>
      )}

      {/* Full Screen Modal */}
      {selectedImage && (
        <div
          style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            background: 'rgba(0,0,0,0.9)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 1000,
            cursor: 'default'
          }}
          onClick={closeImageModal}
        >
          {/* Kapatma Butonu */}
          <div style={{ position: 'absolute', top: 20, right: 20, cursor: 'pointer', color: 'white', fontSize: 30 }}>
             <CloseOutlined />
          </div>

          <div 
             style={{ position: 'relative', maxWidth: '90vw', maxHeight: '90vh' }}
             onClick={(e) => e.stopPropagation()} // Resme tıklayınca kapanmasın
          >
            <img
              src={selectedImage.url}
              alt={selectedImage.filename}
              style={{ maxWidth: '100%', maxHeight: '90vh', objectFit: 'contain', borderRadius: 4 }}
            />
            <div style={{
              position: 'absolute', bottom: -40, left: 0, right: 0,
              textAlign: 'center', color: 'white', fontSize: 16
            }}>
              {selectedImage.filename}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageArchivePage;